// extracted by mini-css-extract-plugin
module.exports = {"container":"ErrorPlaceholder_container__U0dtN"};